import axios from './axios';

export const getYearOverviewReport = ({ params } = {}) => axios.get(`reports/year_overview`, { params });
export const getEstimatesByClientReport = ({ params } = {}) => axios.get(`reports/estimates_by_client`, { params });
export const getLastThreeMonthsReport = ({ params } = {}) => axios.get(`reports/last_three_months`, { params });
export const getTopClientsReport = ({ params } = {}) => axios.get(`reports/top_clients`, { params });
export const getServicesBreakdownReport = ({ params } = {}) => axios.get(`reports/services_breakdown`, { params });
export const getNewProjectsWithOrderReport = ({ params } = {}) => axios.get(`reports/new_projects_with_order`, { params });
